export default __webpack_public_path__ + "static/media/todo.faef7b27.png";